import React from 'react';
import './PageLoader.css';

const PageLoader = ({ message = 'Loading...' }) => {
  return (
    <div className="page-loader-container">
      <div className="page-loader-content">
        <div className="loader-spinner"></div>
        <p className="loader-message">{message}</p>
      </div>
    </div>
  );
};

export default PageLoader;
